/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'ip-addr-match-readonly';
const prefix = `${moduleName}.${componentName}`;

export const clientIpAddressLabel = `${prefix}.clientIpAddressLabel`;

export const ENGLISH = {
    [clientIpAddressLabel]: 'Client IP Address',
};
